// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export var _DYN_CONNECTION_STRING = "connectionString"; // Count: 3
export var _DYN_VERSION = "version"; // Count: 6
export var _DYN_QUEUE = "queue"; // Count: 6
export var _DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 4
export var _DYN_USER_OVERRIDE_ENDPOI0 = "userOverrideEndpointUrl"; // Count: 5
export var _DYN_ENDPOINT_URL = "endpointUrl"; // Count: 5
export var _DYN_ONUNLOAD_FLUSH = "onunloadFlush"; // Count: 6
export var _DYN_CONTEXT = "context"; // Count: 5
export var _DYN_ADD_HOUSEKEEPING_BEF1 = "addHousekeepingBeforeUnload"; // Count: 2
export var _DYN_SEND_MESSAGE = "sendMessage"; // Count: 3
export var _DYN_UNLOAD = "unload"; // Count: 5
export var _DYN_REMOVE_NOTIFICATION_2 = "removeNotificationListener"; // Count: 2
export var _DYN_UPDATE_SNIPPET_DEFIN3 = "updateSnippetDefinitions"; // Count: 2
export var _DYN_LOGGER = "logger"; // Count: 5
export var _DYN_ATTRIB_CONTAINER = "attribContainer"; // Count: 5
export var _DYN_ATTRIBUTES = "attributes"; // Count: 5
export var _DYN_SPAN_CONTEXT = "spanContext"; // Count: 6
export var _DYN_TRACE_ID = "traceId"; // Count: 4
export var _DYN_SPAN_ID = "spanId"; // Count: 9
export var _DYN_KIND = "kind"; // Count: 6
export var _DYN_BASE_DATA = "baseData"; // Count: 6
export var _DYN_TYPE = "type"; // Count: 12
export var _DYN_RESPONSE_CODE = "responseCode"; // Count: 4
export var _DYN_TARGET = "target"; // Count: 7
export var _DYN_TRACE_FLAGS = "traceFlags"; // Count: 3
//# sourceMappingURL=__DynamicConstants.js.map